import { Box } from '@mui/material';

type Props = {
    width: number;
    height: number;
};

export const Logo = ({ width, height }: Props) => {
    return (
        <Box
            sx={{
                width,
                height,
                backgroundImage: 'url("/images/weatherToolsBlue.svg")',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
            }}
        ></Box>
    );
};
